import { Component } from '@verndale/core';

class IconCardRow extends Component {
  setupDefaults() {
    this.dom = {
      $buttons: this.el.querySelectorAll(".icon-card-row__card-toggle")
    };
  }

  addListeners() {
    this.dom.$buttons.forEach($button => {
      $button.addEventListener('click', this.toggleCard.bind($button));
    });
  }

  toggleCard(e) {
    e.preventDefault();
    e.stopPropagation();
    const card = e.target.closest('.icon-card-row__card');
    card.classList.toggle("icon-card-row__card--open");
  }
}

export default IconCardRow;
